/* ==========================================================================
   assets/tl-sticky-buy.js. NEW FILE, lane landers-dfb31-quad-b-1010, 2026-10-10.
   Drives snippets/tl-sticky-buy.liquid. Reads the buy column (data-no-buy-*), never
   its own copy of a price or a variant: the bar only mirrors and presses.
   NO EM DASHES OR EN DASHES ANYWHERE IN THIS FILE.
   ========================================================================== */
(function () {
  var bar = document.querySelector('[data-tl-sticky]');
  var form = document.querySelector('form[data-no-buy-form]');
  if (!bar || !form) return;
  var btn = bar.querySelector('[data-tl-sticky-btn]');
  var tier = bar.querySelector('[data-tl-sticky-tier]');
  var price = bar.querySelector('[data-tl-sticky-price]');
  var add = form.querySelector('[data-no-buy-add]');

  function sync() {
    var g = document.querySelector('[data-no-buy-v="grade"]');
    var p = form.querySelector('[data-no-buy-price]');
    if (g && tier) tier.textContent = g.textContent.trim();
    if (p && price) price.textContent = p.textContent.trim();
    var off = !add || add.disabled;
    btn.setAttribute('aria-disabled', off ? 'true' : 'false');
    btn.textContent = off ? 'Choose tier' : 'Add to cart';
  }
  function show(on) {
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    btn.tabIndex = on ? 0 : -1;
    if (on) sync();
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var e = es[0];
      show(!e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(form);
  }
  form.addEventListener('click', function () { setTimeout(sync, 60); });
  form.addEventListener('input', function () { setTimeout(sync, 60); });
  btn.addEventListener('click', function () {
    sync();
    if (add && !add.disabled) { add.click(); return; }
    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
}());
